import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  id: "wide",
  style: {"z-index":"auto","position":"static","top":"auto"},
  class: ""
}
const _hoisted_2 = { id: "inwide" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("a", {
  href: "/en/",
  id: "logo-sm"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "https://aurora-oil.ru/wp-content/themes/auroraoil/css/logo-sm.png",
    alt: ""
  })
], -1)
const _hoisted_4 = ["id"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getMenu, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item.id,
          class: "menu-shapka-kolonka-1-container"
        }, [
          _createElementVNode("ul", {
            id: `menu-shapka-kolonka-` + item.id,
            class: "menu"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.items, (link) => {
              return (_openBlock(), _createElementBlock("li", {
                key: link.target
              }, [
                _createVNode(_component_router_link, {
                  to: link.target
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(link.title), 1)
                  ]),
                  _: 2
                }, 1032, ["to"])
              ]))
            }), 128))
          ], 8, _hoisted_4)
        ]))
      }), 128)),
      _hoisted_5
    ])
  ]))
}